import { Flex } from "@chakra-ui/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { lazy, useEffect } from "react";

const Header = lazy(() => import("./components/custom/Header"));
const Footer = lazy(() => import("./components/custom/Footer"));
const HomeScreen = lazy(() => import("./screens/HomeScreen"));
const ScrollToTop = lazy(() => import("./components/custom/ScrollToTop"));
const AboutScreen = lazy(() => import("./screens/AboutScreen"));
const ContactScreen = lazy(() => import("./screens/ContactScreen"));
const ProductsScreen = lazy(() => import("./screens/ProductsScreen"));
const TncScreen = lazy(() => import("./screens/TncScreen"));
const ErrorScreen = lazy(() => import("./screens/ErrorScreen"));

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 500,
      once: false,
      mirror: true,
      easing: "linear",
      offset: 200,
    });
  }, []);
  return (
    <BrowserRouter>
      <Header />
      <Flex direction="column" as="main">
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/about" element={<AboutScreen />} />
          <Route path="/shop" element={<ProductsScreen />} />
          <Route path="/contact" element={<ContactScreen />} />
          <Route path="/terms&conditions" element={<TncScreen />} />
          <Route path="*" element={<ErrorScreen />} />
        </Routes>
        <ScrollToTop />
      </Flex>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
